<div class="teams-category-container" *ngIf="teamService.team$ | async; let team">
    <div class="team-container">
        <div class="team-progress-container py-12">
            <div fxLayoutAlign="space-between center" class="mb-8">
                <h2 class="font-normal text-lg">{{ 'TEAMS.TEAM_PROGRESS.TITLE' | translate }}</h2>
                <mat-slide-toggle (change)="toggleTeamProgressChanged($event)" [checked]="isTrackSubTeamProgressActive.value" *ngIf="team.subteamCount">
                    {{ 'TEAMS.TEAM_PROGRESS.LABEL.INCLUDE_SUBTEAMS_PROGRESS' | translate }}
                </mat-slide-toggle>
            </div>

            <div
                *ngIf="
                    team.charts.length ||
                        isCertificateMgmtFeatureEnabled ||
                        isPerformanceReviewFeatureActive ||
                        (isTeamDetailsPage && isCourseCatalogFeatureEnabled && bookingsTeamOverview);
                    else noTeamProgress
                "
            >
                <div fxLayout="row wrap" fxLayoutAlign="flex-start space-between" fxLayoutGap.gt-xs="8px grid">
                    <mat-card
                        appearance="outlined"
                        fxLayout="row"
                        fxLayoutAlign="flex-start space-between"
                        fxFlex="1 0 calc(100%-8px)"
                        fxFlex.gt-xs="1 0 calc(50%-8px)"
                        fxFlex.gt-md="1 0 calc(33.33%-8px)"
                        class="mb-12 p-0 team-progress-card-container mat-elevation-z0"
                    >
                        <app-course-completion class="w-100-p" [charts]="team.charts"></app-course-completion>
                    </mat-card>

                    <mat-card
                        appearance="outlined"
                        fxLayout="row"
                        fxLayoutAlign="flex-start space-between"
                        fxFlex="1 0 calc(100%-8px)"
                        fxFlex.gt-xs="1 0 calc(50%-8px)"
                        fxFlex.gt-md="1 0 calc(33.33%-8px)"
                        class="mb-12 p-0 team-progress-card-container mat-elevation-z0"
                    >
                        <app-active-days class="w-100-p" [team]="team"></app-active-days>
                    </mat-card>

                    <mat-card
                        appearance="outlined"
                        fxLayout="row"
                        fxLayoutAlign="flex-start space-between"
                        fxFlex="1 0 calc(100%-8px)"
                        fxFlex.gt-xs="1 0 calc(50%-8px)"
                        fxFlex.gt-md="1 0 calc(33.33%-8px)"
                        class="mb-12 p-0 team-progress-card-container mat-elevation-z0"
                    >
                        <app-average-learning-time class="w-100-p" [horizontalView]="false" [avgLearningTime]="team.avgLearningTime"></app-average-learning-time>
                    </mat-card>

                    <mat-card
                        appearance="outlined"
                        fxLayout="row"
                        fxLayoutAlign="flex-start space-between"
                        fxFlex="1 0 calc(100%-8px)"
                        fxFlex.gt-xs="1 0 calc(50%-8px)"
                        fxFlex.gt-md="1 0 calc(33.33%-8px)"
                        class="mb-12 p-0 team-progress-card-container mat-elevation-z0 pointer"
                        (click)="openTeamCertificatesDialog()"
                        *ngIf="isCertificateMgmtFeatureEnabled && canViewCertificates"
                    >
                        <app-team-certificates
                            class="w-100-p"
                            [totalCount]="team.certificateStats.totalCount"
                            [expiredCount]="team.certificateStats.expiredCount"
                        ></app-team-certificates>
                    </mat-card>

                    <mat-card
                        appearance="outlined"
                        fxLayout="row"
                        fxLayoutAlign="flex-start space-between"
                        fxFlex="1 0 calc(100%-8px)"
                        fxFlex.gt-xs="1 0 calc(50%-8px)"
                        fxFlex.gt-md="1 0 calc(33.33%-8px)"
                        class="mb-12 p-0 team-progress-card-container mat-elevation-z0 pointer"
                        *ngIf="isTrainingApprovalRequestsFeatureEnabled && canViewApprovalRequests"
                    >
                        <app-team-approval-requests class="w-100-p" [approvalRequestsTeamOverview]="approvalRequestsTeamOverview" [teamId]="teamId"></app-team-approval-requests>
                    </mat-card>

                    <mat-card
                        appearance="outlined"
                        fxLayout="row"
                        fxLayoutAlign="flex-start space-between"
                        fxFlex="1 0 calc(100%-8px)"
                        fxFlex.gt-xs="1 0 calc(50%-8px)"
                        fxFlex.gt-md="1 0 calc(33.33%-8px)"
                        class="mb-12 p-0 team-progress-card-container mat-elevation-z0"
                        *ngIf="performanceTeamOverview"
                    >
                        <app-performance-team-review
                            class="w-100-p"
                            [performanceTeamOverview]="performanceTeamOverview"
                            [teamId]="teamId"
                            [isPerformanceReviewTileClickable]="isPerformanceReviewTileClickable"
                        ></app-performance-team-review>
                    </mat-card>

                    <mat-card
                        appearance="outlined"
                        fxLayout="row"
                        fxLayoutAlign="flex-start space-between"
                        fxFlex="1 0 calc(100%-8px)"
                        fxFlex.gt-xs="1 0 calc(50%-8px)"
                        fxFlex.gt-md="1 0 calc(33.33%-8px)"
                        class="mb-12 p-0 team-progress-card-container mat-elevation-z0 pointer"
                        *ngIf="isCourseCatalogFeatureEnabled && bookingsTeamOverview && canViewBookings"
                    >
                        <app-team-bookings class="w-100-p" [bookingsTeamOverview]="bookingsTeamOverview" [teamId]="teamId"></app-team-bookings>
                    </mat-card>
                </div>
            </div>

            <ng-template #noTeamProgress>
                <div fxLayout="column" fxLayoutAlign="center center" class="no-team-progress-container p-32 bg-white">
                    <mat-icon class="participant-view-illustration" svgIcon="team_progress_illustration"></mat-icon>
                    <h3 class="mt-8 mb-4">
                        {{ 'TEAMS.TEAM_PROGRESS.LABEL.NO_PROGRESS_YET' | translate }}
                    </h3>
                    <div *ngIf="!(teamService.teamMembers$ | async).length" fxLayout="column" fxLayoutAlign="center center">
                        <p class="mt-0 mb-16">
                            {{
                                (team.isCurrentUserLeader || isCurrentUserTenantAdmin
                                    ? 'TEAMS.TEAM_PROGRESS.LABEL.ADD_MEMBERS_TO_SEE_PROGRESS'
                                    : 'TEAMS.TEAM_PROGRESS.LABEL.SHOW_PROGRESS'
                                ) | translate
                            }}
                        </p>

                        <app-flat-button
                            class="mb-12"
                            [icon]="'add'"
                            [label]="'TEAMS.MEMBER.BUTTON.ADD_MEMBER'"
                            (onClick)="openAddDialog()"
                            *ngIf="team.isCurrentUserLeader || isCurrentUserTenantAdmin"
                        ></app-flat-button>
                    </div>
                </div>
            </ng-template>
        </div>

        <app-team-leaders
            [teamId]="teamId"
            [allUser$]="allUser$"
            [filteredAllUsers$]="filteredAllUsers$"
            [isTeamDetailsPage]="isTeamDetailsPage"
            [isTrackSubTeamProgressActive]="isTrackSubTeamProgressActive.value"
            [canManageTeamLeaders]="(team.isCurrentUserLeader && team.isCurrentUserTeamLeaderSubteams) || isCurrentUserTenantAdmin"
        ></app-team-leaders>

        <app-team-training-responsibles
            [teamId]="teamId"
            [allUser$]="allUser$"
            [filteredAllUsers$]="filteredAllUsers$"
            [isTeamDetailsPage]="isTeamDetailsPage"
            [canManageTrainingResponsibles]="(team.isCurrentUserLeader && team.isCurrentUserTeamLeaderSubteams) || isCurrentUserTenantAdmin"
        ></app-team-training-responsibles>

        <app-team-members
            [teamId]="teamId"
            [allUser$]="allUser$"
            [filteredAllUsers$]="filteredAllUsers$"
            [isTeamDetailsPage]="isTeamDetailsPage"
            [isTrackSubTeamProgressActive]="isTrackSubTeamProgressActive.value"
            [canManageTeamMembers]="team.isCurrentUserLeader || team.isCurrentUserTeamLeaderSubteams || (isCurrentUserTenantAdmin && !isTeamDetailsPage)"
        ></app-team-members>

        <app-team-subteams
            [teamId]="teamId"
            [canManageSubteams]="team.isCurrentUserLeader || team.isCurrentUserTeamLeaderSubteams"
            [parentIsTrainingResponsible]="team.isCurrentUserTrainingResponsible || team.isCurrentUserUpperTrainingResponsible"
            *ngIf="isTeamDetailsPage"
        ></app-team-subteams>
    </div>
</div>
